export default __webpack_public_path__ + "static/media/logo_green.fbe8a415.png";